import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactUs from '../components/ContactUs';
import SEO from '../components/SEO';

function ContactPage({ onHomeClick, onAboutClick, onContactClick, onCourseSelect, onEnrollClick, activePage, selectedCourse, setIsMobileMenuOpen }) {
  const [isMobileMenuOpen, setLocalMobileMenuOpen] = useState(false);
  const pageTopRef = useRef(null);

  // Force scroll to top on mount
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  // Handle mobile menu state
  const handleMobileMenuToggle = (isOpen) => {
    setLocalMobileMenuOpen(isOpen);
    if (setIsMobileMenuOpen) setIsMobileMenuOpen(isOpen);
  };

  // Control call button and Tawk chat visibility based on mobile menu state
  useEffect(() => {
    const callButton = document.getElementById('call-button');
    const tawkChatBox = document.getElementById('tawkchat-minified-box');
    const tawkContainer = document.getElementById('tawkchat-container');

    if (isMobileMenuOpen) {
      if (callButton) callButton.style.display = 'none';
      if (tawkChatBox) tawkChatBox.style.display = 'none';
      if (tawkContainer) tawkContainer.style.display = 'none';
    } else {
      if (callButton) callButton.style.display = 'flex';
      if (tawkChatBox) tawkChatBox.style.display = 'block';
      if (tawkContainer) tawkContainer.style.display = 'block';
    }
  }, [isMobileMenuOpen]);



  return (
    <div ref={pageTopRef}>
      <SEO title="Contact Oranium Tech Chennai | For Course Enquiries" description="Contact us for IT & Software course enquiries, training schedules and enrollment details. Get expert guidance to choose the right course. Contact us today." />
      <Helmet>
        <title>Contact Oranium Tech Chennai | For Course Enquiries</title>
        <meta name="description" content="Contact us for IT & Software course enquiries, training schedules and enrollment details. Get expert guidance to choose the right course. Contact us today." />

        {/* Geo Meta Tags */}
        <meta name="geo.region" content="IN-TN" />
        <meta name="geo.placename" content="Chennai" />
        <meta name="geo.position" content="12.982669614636563;80.21911627454672" />
        <meta name="ICBM" content="12.982669614636563, 80.21911627454672" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Oranium Tech",
            "url": "https://oraniumtech.com",
            "logo": "https://oraniumtech.com/logo.png",
            "description": "Leading IT training institute in Chennai offering courses in AI, Cloud, DevOps, Testing, and Full-Stack Development",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Chennai",
              "addressRegion": "Tamil Nadu",
              "addressCountry": "IN"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-7871719161",
              "contactType": "Customer Service",
              "areaServed": "IN",
              "availableLanguage": ["English", "Tamil"]
            },
            "sameAs": [
              "https://www.facebook.com/oraniumtech",
              "https://www.linkedin.com/company/oraniumtech",
              "https://www.instagram.com/oraniumtech"
            ]
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            "@id": "https://oraniumtech.com/velachery",
            "name": "Oranium Tech - Velachery",
            "image": "https://oraniumtech.com/velachery-branch.jpg",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "52, Ponniamman Complex, 2nd Floor, Velachery Main Rd, nearby Dhandeeswaram Bus Stop",
              "addressLocality": "Velachery",
              "addressRegion": "Tamil Nadu",
              "postalCode": "600042",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "12.982669614636563",
              "longitude": "80.21911627454672"
            },
            "telephone": "+91-7871719161",
            "email": "oraniumtech@gmail.com",
            "url": "https://oraniumtech.com",
            "priceRange": "₹₹",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "09:00",
                "closes": "20:00"
              }
            ],
            "areaServed": {
              "@type": "City",
              "name": "Chennai"
            },
            "hasMap": "https://goo.gl/maps/velachery",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "500"
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            "@id": "https://oraniumtech.com/chrompet",
            "name": "Oranium Tech - Chrompet",
            "image": "https://oraniumtech.com/chrompet-branch.jpg",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "9, 2nd Floor, 14th cross street, New Colony",
              "addressLocality": "Chrompet",
              "addressRegion": "Tamil Nadu",
              "postalCode": "600044",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "12.947812815400399",
              "longitude": "80.1338436745462"
            },
            "telephone": "+91-7871719161",
            "email": "oraniumtech@gmail.com",
            "url": "https://oraniumtech.com",
            "priceRange": "₹₹",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "09:00",
                "closes": "20:00"
              }
            ],
            "areaServed": {
              "@type": "City",
              "name": "Chennai"
            },
            "hasMap": "https://goo.gl/maps/chrompet",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "500"
            }
          })}
        </script>
      </Helmet>
      <Header
        onCourseSelect={onCourseSelect}
        onEnrollClick={onEnrollClick}
        activePage={activePage}
        onHomeClick={onHomeClick}
        onAboutClick={onAboutClick}
        onContactClick={onContactClick}
        selectedCourse={selectedCourse}
        onMobileMenuToggle={handleMobileMenuToggle}
      />
      <ContactUs />
      <Footer
        onHomeClick={onHomeClick}
        onAboutClick={onAboutClick}
        onContactClick={onContactClick}
        onCourseSelect={onCourseSelect}
      />
    </div>
  );
}

export default ContactPage;